import * as React from 'react';

const ExpressIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    fill="none"
    viewBox="0 0 12 10"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 7.75H1.25M2.75 5H.5M4 2.25H1.5M8 .5 4.702 5.118c-.146.204-.22.306-.216.391a.25.25 0 0 0 .097.189c.068.052.193.052.444.052H7.5L7 9.5l3.298-4.617c.146-.205.22-.307.216-.392a.25.25 0 0 0-.097-.189c-.067-.052-.193-.052-.444-.052H7.5z"
    ></path>
  </svg>
);

export default ExpressIcon;
